var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time-order-box"},[_c('div',{staticClass:"time-order-tool"}),_c('div',{staticClass:"time-order-charts",attrs:{"id":"timeCharts"}})])
}]

export { render, staticRenderFns }